// Address-to-address driving distance. The lookup runs on your own Supabase Edge Function
// (supabase/functions/route-distance), which keeps the map-provider key off the device.
// Only the distance is cached on this device, keyed by the text you typed, so repeat trips cost nothing.
import { remote } from "./remote.js";

const KEY = "bb_route_cache_v1";
const M_PER_MILE = 1609.344;
const ISO = { US: "us", UK: "gb", AU: "au", NZ: "nz", CA: "ca", IN: "in", SG: "sg", JP: "jp" };
const norm = (s) => String(s || "").trim().toLowerCase().replace(/\s+/g, " ");
const load = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch (e) { return {}; } };
const save = (c) => { try { const k = Object.keys(c); if (k.length > 300) k.slice(0, k.length - 300).forEach((x) => delete c[x]); localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) { /* private mode */ } };

export const countryCode = (c) => ISO[c] || "";
export const metersToUnit = (m, unit) => Math.round((m / (unit === "km" ? 1000 : M_PER_MILE)) * 10) / 10;

export async function addressDistance({ from, to, country, unit }) {
  const a = String(from || "").trim(), b = String(to || "").trim();
  if (a.length < 3 || b.length < 3) throw new Error("Type both addresses first.");
  const key = `${norm(a)}|${norm(b)}|${country || ""}`;
  const cache = load();
  if (cache[key]) return { distance: metersToUnit(cache[key], unit), cached: true };
  const r = await remote.routeDistance({ from: a, to: b, country: countryCode(country) });
  cache[key] = r.meters; save(cache);
  return { distance: metersToUnit(r.meters, unit), fromLabel: r.fromLabel, toLabel: r.toLabel, cached: false };
}
